var map = {
	"./App.css": [
		50
	],
	"./Chargement.css": [
		375
	],
	"./color-1.css": [
		640,
		640
	],
	"./color-2.css": [
		267,
		267
	],
	"./color-3.css": [
		22,
		22
	],
	"./color-4.css": [
		145,
		145
	],
	"./color-5.css": [
		36,
		36
	],
	"./index.css": [
		555
	],
	"./style-sitcher.css": [
		883
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 599;
module.exports = webpackAsyncContext;